<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">图书馆服务</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <div class="twodiv">
        </div>
        <div class="twodiv">
          我公司可以为图书馆人员外包、活动外包以及加工外包等相关服务。
        </div>
        <div class="twodiv">
          图书馆作为文化发展的前沿阵地，肩负着为广大读者提供优质的图书、舒适的阅读体验和便捷的借阅流程等多个重担。如何提升图书馆运营管理水平是一个迫切需要解决的难题。从2010年前后开始，很多原本由政府运营的公共图书馆开始寻求社会力量的参与，以企业专业团队和丰富经验为助力，将图书馆的运营服务开展的更好。
        </div>
        <div class="twodiv">
          图书馆的运营涵盖了很多方面，比如活动策划、人员管理、图书管理等等，图书馆服务外包可以按照企业可运营的程度，分为全馆型服务外包模式、半馆型服务外包模式及软硬件服务外包模式。全馆型服务外包非常全面，包括图书馆的整体规划、管理和运营；半馆型服务外包则是部分服务外包，如人员外包、活动外包加工服务外包等；而软硬件服务外包是指采购相关软硬件设备。
        </div>
        <div class="twodiv">
          图书馆服务外包对图书馆来说有哪些作用？
        </div>
        <div class="threediv">
          1、资金方面：企业与政府合作，能够相对减轻公共财政投入不足的问题；
        </div>
        <div class="threediv">
          2、人员问题：相比传统运营方式，企业拥有专业的管理团队和丰富的管理经验，不但可以完善图书馆的人才队伍，还能解决编制紧张的问题；
        </div>
        <div class="threediv">
          3、管理模式：企业可以为图书馆注入新鲜的血液，为图书馆运营激发创新活力，年轻团队配合成熟的管理服务体系，让图书馆运营多样化与高效化；
        </div>
        <div class="threediv">
          4、服务水平：从人员、图书、活动等多个方面共同着手，整体提升图书馆的服务质量，快速培育读者群体，增强文化氛围，创造更高的社会效益；
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'ProductFuwu',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Fuwu.vue